import { Button,  Checkbox } from "@nike/eds";
import  { useState } from "react";
import { Menu, MenuItem } from "@nike/eds";

import { CaretDown, CaretUp } from "@nike/nike-design-system-icons";

type GeoSelectProps = {
    currentGeos: string[];
    setCurrentGeos: (geos: string[]) => void;
};


function MenuBody({ currentGeos, setCurrentGeos }: GeoSelectProps) {

  const handleToggle = (geo: string) => {
    if (currentGeos.includes(geo)) {
      // Only allow unchecking if more than one geo is selected
      if (currentGeos.length > 1) {
        setCurrentGeos(currentGeos.filter(g => g !== geo));
      }
      // else do nothing (prevent unchecking last)
    } else {
      setCurrentGeos([...currentGeos, geo].sort());
    }
  };
  
  return (
    <>
      <MenuItem>
        <Checkbox id="cb-apla" name="APLA" label="APLA" value="APLA" checked={currentGeos.includes("APLA")} onChange={() => handleToggle("APLA")} />
      </MenuItem>
      <MenuItem>
        <Checkbox id="cb-emea" name="EMEA" label="EMEA" value="EMEA" checked={currentGeos.includes("EMEA")} onChange={() => handleToggle("EMEA")} />
      </MenuItem>
      <MenuItem>
        <Checkbox id="cb-us" name="US" label="US" value="US" checked={currentGeos.includes("US")} onChange={() => handleToggle("US")} />
      </MenuItem>
    </>
  );
}


export function GeoSelector({currentGeos, setCurrentGeos}: GeoSelectProps) { 
    const [open, setOpen] = useState(false);

    return (
        <div className="eds-flex eds-flex--align-items-left eds-flex--justify-content-space-between">
            <Menu
                onClickOutside={() => {
                setOpen(!open);
                }}
                isOpen={open}
                headerSlot={<></>}
                bodySlot={<MenuBody currentGeos={currentGeos} setCurrentGeos={setCurrentGeos} />}
                footerSlot={<></>}
                placement={"bottom-start"}
            >
                <Button
                size="small"
                beforeSlot={open ? <CaretUp /> : <CaretDown />}
                variant="secondary"
                onClick={() => setOpen(!open)}
                aria-haspopup="menu"
                >
                {currentGeos.length > 0 ? `Geos: ${currentGeos.join(", ")}` : "Click to set Geos"}
                </Button>
            </Menu>

        </div>
    );
}

